import { Component, OnInit } from '@angular/core';
import {
	Data, DataLoaderService, CommonDataService, AlternateOptionsService,
	PriceCalculationService, ProgressBarService, SummaryService, SortingService
} from '../service-call-index';
import { SummaryValidationComponent } from './../summary-validations/summary-validations.component';
import { AlternateScreenComponent } from '../../alternate-options/alternate-options.component';
@Component({
	selector: 'additional-color-options',
	templateUrl: './additional-color.template.html',
	styleUrls: ['./additional-color.component.css'],
})
export class AdditionalColorOptions implements OnInit {
	public additionalColor: Data[];
	public saved: Data[];
	public toggleContViewAddColor: boolean = false;
	public currency: string;
	private selectedPackageOptions: Data[] = [];
	public colorSuggList = [];
	public errMessage;
	public lengthOfAddColor: number;


	constructor(private dataLoaderService: DataLoaderService, private commonDataService: CommonDataService,
		private summaryService: SummaryService, private priceCalculationService: PriceCalculationService,
		private progressService: ProgressBarService, private alternateOptionsService: AlternateOptionsService,
		private summaryValidationComponent: SummaryValidationComponent, private sortingService: SortingService,private alternateScreenComponent: AlternateScreenComponent) {
		this.currency = this.dataLoaderService.data.currencyType;
		this.additionalColor = this.dataLoaderService.data.additionalColor;
	}
	ngOnInit() {
		this.summaryService.getSelectedOptions();

		this.progressService.progressBarValidation();
		if (this.commonDataService.addColorFlag) {
			this.toggleContViewAddColor = true;
		}

		//fetching length for displaying in HTML
		this.lengthOfAddColor = this.dataLoaderService.data.additionalColor.length;


		//On load	
		let adcolor;
		this.additionalColor.forEach(element => {
			if (element.selected === true) {
				adcolor = element;
				this.saved = adcolor;
				this.priceCalculationService.notifyNormalCompItem({ fromComponent: "normalAddColor", data: [adcolor] });
			}
		});
	}
	/**
	 * To select an additional color option and send the selected option to the Summary screen
	 * @param item of Data type
	 * @returns none
	 */
	selectAdditionalColor(item) {
		setTimeout(() => {
			this.progressService.illuminateRed();
		}, 0);
		this.dataLoaderService.flagDictionary.resetAddColorFlag = false;
		this.dataLoaderService.flagDictionary.loadingFlag = true;
		this.progressService.illuminateYellow();
		this.dataLoaderService.flagDictionary.alternateOverlayFlag = true;

		let index: number = -1;
		if (this.dataLoaderService.vehicleInfo.urlFlag === '0' || this.dataLoaderService.vehicleInfo.urlFlag === '1') {
			let returnAlternateValues = this.alternateOptionsService.getAlternateOptionsNormal(item);
			returnAlternateValues.subscribe(
				alternateResponse => {
					if (alternateResponse.suggestions[0].addedCodes.length > 0 || alternateResponse.suggestions[0].removedCodes.length > 0) {
						this.colorSuggList = alternateResponse.suggestions;
						this.commonDataService.sendSuggestion(this.colorSuggList);
						this.openAlternateScreen();
						this.dataLoaderService.flagDictionary.loadingFlag = false;
					}
					else {
						for (let i in this.additionalColor) {
							if (this.additionalColor[i].code === item.code) {
								this.additionalColor[i].selected = true;
								//Updated prices from validation response
								this.alternateScreenComponent.updatedPrices();
								this.dataLoaderService.previousExpertAddColor[0] = this.additionalColor[i]

							} else {
								this.additionalColor[i].selected = false;
								for (let s in this.dataLoaderService.gccUpdatedPrices) {
										for(let k in this.additionalColor){
											if ((this.additionalColor[k].code == this.dataLoaderService.gccUpdatedPrices[s].code) && (this.additionalColor[k].codeType == this.dataLoaderService.gccUpdatedPrices[s].codeType)) {
												this.additionalColor[k].price = this.dataLoaderService.gccUpdatedPrices[s].price;
										}
									}
								}
							}
						
						}
						this.saved = item;
						this.dataLoaderService.flagDictionary.alternateOverlayFlag = false;
						this.dataLoaderService.flagDictionary.loadingFlag = false;
						this.saveAddColor();
					}
					this.dataLoaderService.selectedAddColor=item;
					this.sortingService.sortCodes(this.additionalColor, true)
				},
				err => {
					if (err._body !== undefined) {
						this.errMessage = err._body;
						this.commonDataService.notifyErrorMsgItem(this.errMessage);
						this.openAlternateErrorScreen();
						this.dataLoaderService.flagDictionary.loadingFlag = false;
					}
				}
			);
		} else {
			for (let i in this.additionalColor) {
				if (this.additionalColor[i].code === item.code) {
					this.additionalColor[i].selected = true;
				} else {
					this.additionalColor[i].selected = false;
				}
				this.saved = item;
				if (this.saved) {
					this.dataLoaderService.flagDictionary.validated = false;
					this.selectedPackageOptions.unshift(item);
				}
			}
			this.dataLoaderService.flagDictionary.validated = false;
			this.dataLoaderService.flagDictionary.alternateOverlayFlag = false;
			this.dataLoaderService.flagDictionary.loadingFlag = false;
			this.sortingService.sortCodes(this.additionalColor, true)
			this.saveAddColor();
		}
		this.progressService.progressBarValidation();
	}
	/**
	 * To go to the next Tab:Trim tab when clicked on the Continue button
	 * @param none
	 * @returns none
	 */
	gotoNextTab() {
		this.commonDataService.notifyOther({ option: 'activeUpholstery' });
	}
	saveAddColor() {
		if (this.saved !== undefined) {
			this.priceCalculationService.notifyNormalCompItem({ fromComponent: "normalAddColor", data: [this.saved] });
			this.priceCalculationService.notifyExpertCompItem({ fromComponent: "expertAddColor", data: [this.saved] });
			this.priceCalculationService.normalModePriceCalculation();
		}
		this.progressService.progressBarValidation();
	}

	openAlternateScreen() {
		if (this.dataLoaderService.vehicleInfo.urlFlag === '0' || this.dataLoaderService.vehicleInfo.urlFlag === '1') {
			this.dataLoaderService.flagDictionary.alternateErrorFlag = false;
			this.dataLoaderService.flagDictionary.alternateValidateFlag = true;
			this.progressService.illuminateRed();
		
		}
	}
	openAlternateErrorScreen() {
		this.dataLoaderService.flagDictionary.alternateErrorFlag = true;
		this.dataLoaderService.flagDictionary.alternateValidateFlag = false;
		this.progressService.illuminateRed();
		
	}
	validate() {
		this.summaryValidationComponent.alternateOptionsForURLFlag2Validate();
	}
}



// WEBPACK FOOTER //
// ./src/app/components/selectable-tabs/normal-screen-components/additional-color/additional-color.component.ts